import React, { useEffect, useMemo, useState } from 'react';
import API from '../apiCalls/accountAPI';
import get from 'lodash/get';
import { getCookie } from '../util/index';
import { showChatApp } from './helper';

const WithChatService = (Component) => {
  const EnhancedComponent = (props) => {
    const chatEnabled = showChatApp();
    const [kxUser, setKxUser] = useState(null);
    const [KChatService, setKChatService] = useState(null);

    const userToken = getCookie(window.GLOBAL_MAIN_TOKEN_KXBROKERTOKEN);

    const envUrls = useMemo(
      () => ({
        API_URL: window._env_.REACT_APP_BROKER_API_URL,
        DOCUMENT_URL: window._env_.REACT_APP_MEDIA_URL,
        CHAT_APP_URL: `wss://${window._env_.REACT_APP_CHAT_SOCKET_URL}`,
        CHAT_DOCUMENT_BUCKET: window._env_.CHAT_DOCUMENT_BUCKET,
      }),
      []
    );

    const getUserDetails = () => {
      API.getKxuser(userToken)
        .then((res) => {
          return res.json();
        })
        .then((res) => {
          setKxUser(get(res, 'eventMessage.userBasicInfo', null));
        })
        .catch((err) => {
          console.error(err);
        });
    };

    useEffect(() => {
      if (!chatEnabled) {
        return;
      }
      import('kn-chat-app')
        .then((mod) => setKChatService(() => mod.KChatService))
        .catch(() => {});
      if (userToken) {
        getUserDetails();
      }
    }, [chatEnabled, userToken]);

    if (!chatEnabled) {
      return <Component {...props} />;
    }
    if (userToken && !KChatService) {
      return <div className="async-jobqueue-fallback" aria-hidden="true" />;
    }
    if (userToken && KChatService) {
      return (
        <KChatService
          token={userToken}
          userGuid={get(kxUser, 'userGuid', '')}
          envUrls={envUrls}
          platformDetails={{ is360: true }}
        >
          <Component {...props} />
        </KChatService>
      );
    }
    return <Component {...props} />;
  };
  return EnhancedComponent;
};

export default WithChatService;
